module.exports = __webpack_public_path__ + "static/media/logo_white.bcb4728e.svg";